// Browser detection used by the donate flow to surface accurate guidance
// when Stripe Elements is blocked by a privacy setting. Stripe relies on
// cross-origin iframes (m.stripe.network, js.stripe.com) which are exactly
// what Firefox Strict ETP / Brave Shields block.
//
// Note: feature-detection would be cleaner, but the FAILURE we want to warn
// about is "the iframe never loaded" — there's no synchronous API for that.
// Detecting the browser up front lets us show a proactive hint BEFORE the
// donor waits 5s for the Stripe SDK to time out.

export const detectBrowser = () => {
    if (typeof navigator === "undefined") return { name: "unknown" };
    const ua = navigator.userAgent || "";
    // Order matters — Brave/Edge masquerade as Chromium with extra tokens.
    if (/Firefox\//i.test(ua) && !/Seamonkey/i.test(ua)) return { name: "firefox" };
    if ((navigator.brave && navigator.brave.isBrave) || /Brave/i.test(ua)) return { name: "brave" };
    if (/Edg\//.test(ua)) return { name: "edge" };
    if (/Chrome\//i.test(ua) && !/Chromium/i.test(ua)) return { name: "chrome" };
    if (/Safari\//i.test(ua) && /Apple/i.test(navigator.vendor || "")) return { name: "safari" };
    return { name: "other" };
};

// Returns true if the current browser is known to default-block Stripe's
// cross-origin iframes via aggressive tracker-protection. Firefox standard
// mode does NOT block Stripe; only Strict mode does — but we can't tell
// Strict from Standard from JS, so we show the hint to all Firefox users
// and let them dismiss it.
export const isStripeRiskyBrowser = () => {
    const b = detectBrowser();
    return b.name === "firefox" || b.name === "brave";
};
